import { ParticipantListTeamOutputsRequest } from '@amzn/event-engine-events-sdk/clients/eventengineeventsservice';
import { CredentialRoles } from '@amzn/event-engine-js-utils';
import EventEngineClientFactory from 'contexts/EventEngineClientFactory';

const eeEventsClient = EventEngineClientFactory.getClientSingleton(
    'EEEventsClient'
);

const getEEEventsClient = async (role: CredentialRoles = 'Participant') =>
    await eeEventsClient.getClient(role);

export default {
    getParticipantEvent,
    joinEvent,
    getParticipantEventCodeInfo,
    getParticipantTeamCredentials,
    getParticipantTeamLoginLink,
    getParticipantTeamSshKeyPair,
    getParticipantContent,
    getParticipantListTeamOutputs,
    getParticipantListEventOutputs,
};

///////////////// Implementation

async function getParticipantEventCodeInfo(eventCode: string) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient
        .participantGetEventCodeInfo({ eventCode })
        .promise();
}

async function joinEvent(eventCode: string) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient.participantJoinEvent({ eventCode }).promise();
}

async function getParticipantEvent(participantId: string) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient
        .participantGetEvent({ participantId })
        .promise();
}

async function getParticipantTeamCredentials(participantId: string) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient
        .participantGetTeamCredentials({ participantId })
        .promise();
}

async function getParticipantTeamLoginLink(participantId: string) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient
        .participantGetTeamLoginLink({ participantId })
        .promise();
}

async function getParticipantTeamSshKeyPair(participantId: string) {
    const eeEventsClient = await getEEEventsClient();

    return await eeEventsClient
        .participantGetTeamSshKeyPair({ participantId })
        .promise();
}

async function getParticipantContent(participantId: string) {
    const eeEventsClient = await getEEEventsClient();

    return await eeEventsClient
        .participantGetContent({ participantId })
        .promise();
}

async function getParticipantListTeamOutputs(
    params: ParticipantListTeamOutputsRequest
) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient.participantListTeamOutputs(params).promise();
}

async function getParticipantListEventOutputs(
    params: ParticipantListTeamOutputsRequest
) {
    const eeEventsClient = await getEEEventsClient();
    return await eeEventsClient.participantListEventOutputs(params).promise();
}
